import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../context/UserContext/UserContext';

export const useGlobalFilterValues = () => {
  const filterValues = useContextSelector(UserStateContext, (v) => {
    const userLogin = v?.state.userLogin;
    if (userLogin) {
      return v?.state.globalFilterValues[userLogin];
    }
    return [];
  });
  return filterValues;
};
